import { throwError, Observable } from 'rxjs';
import * as serviceUtils from './utility.model';

export interface Error {
  status: string;
  code: string;
}
interface ErrorLogout {
  error?: serviceUtils.ServiceError;
  message?: string;
  status?: number;
  statusText?: string;
}

export const logErrorForLogout = (
  error?: ErrorLogout,
): Observable<ErrorLogout> => {
  let errMsg: string;
  let status: number;

  if (error) {
    const body = error;
    const err = body.error;
    if (err?.errObject?.metadata?.outcome) {
      return throwError({
        errObject: err.errObject.metadata.outcome,
        status: err.errObject.metadata.outcome.status,
        errMsg: err.errObject.metadata.outcome.message,
      });
    }
    status = error.status || 500;

    if (
      (typeof error.error?.errObject?.additionalDetails !== 'undefined' ||
        typeof error.error?.errObject?.developerMessage !== 'undefined') &&
      typeof error.error?.errObject?.message !== 'undefined' &&
      typeof error.error?.errObject?.code !== 'undefined'
    ) {
      // this is cigna outcome status error
      errMsg = `${error.message}`;
    } else {
      // this is for http standard error
      errMsg = error.statusText || '';
    }
  } else {
    errMsg = '';
    status = 500;
  }

  return throwError({
    errMsg,
    status,
    errObject: error,
  });
};
